export class DeviceModel {
    
    private static DEFAULTMODELNAME = "Digital microscope";

    private static _modelName: string | null = null;
    public static get ModelName() {
        if (DeviceModel._modelName == null) {
            return DeviceModel.DEFAULTMODELNAME;
        }

        return DeviceModel._modelName;
    }
    public static set ModelName(value: string | null) {
        DeviceModel._modelName = value;
    }

    public static get ModelNameSentence() {
        if (DeviceModel.ModelName == DeviceModel.DEFAULTMODELNAME) {
            // If the model name is the default the switch it to lowercase
            return DeviceModel.DEFAULTMODELNAME.toLowerCase();
        }

        return DeviceModel.ModelName;
    }
    
    public static Reset() {
        this.ModelName = null;
    }
    
    public static get defaultModelName() {
        return DeviceModel.DEFAULTMODELNAME;
    }
}